<template>
    <v-dialog @click:outside="$emit('subjectCancelled')" v-model="show" width="500">
        <v-card :loading="loading">
            <v-toolbar flat>
                <v-spacer>
                </v-spacer>
                <v-toolbar-title>Add Subject</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <v-row>
                    <v-col cols="12" v-if="errors.non_field_errors">
                        <v-alert type="error">
                            {{errors.non_field_errors[0]}}
                        </v-alert>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field :error-messages="errors.name" autofocus solo v-model="data.name"
                                      label="Subject Name"></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>

                <v-btn @click="save" color="primary">Save</v-btn>
                <v-spacer></v-spacer>
                <v-btn @click="$emit('subjectCancelled')">Cancel</v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "SubjectAddDialog",
        props: {
            show: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                data: {
                    name: ""
                },
                errors: {},
                loading: true
            }
        },
        methods: {
            save() {
                this.loading = true;
                axios.post(apiRoutes.subject.url, this.data).then(response => {
                    this.$store.dispatch("addSubject", response.data)
                    this.$emit("subjectSaved", response.data)
                    this.errors = {}
                    this.data.name = ""
                    this.loading = false
                }).catch(error => {
                    if (error.response.status === 400) {
                        this.errors = error.response.data
                    }
                    this.loading = false
                })
            }
        },
        mounted() {
            this.loading = false
        }
    }
</script>

<style scoped>

</style>